export function Card({ children }) {
  return (
    <div className="h-72 w-[326px] flex flex-col gap-4 rounded-lg bg-white shadow px-5 py-4">
      {children}
    </div>
  )
}

export function CardHeader({ children }) {
  return (
    <div className="shrink-0 font-semibold text-base flex items-center justify-between">
      {children}
    </div>
  )
}

export function CardBody({ children }) {
  return (
    <div className="flex-1 overflow-hidden">
      {children}
    </div>
  )
}

export function CardFooter({ children }) {
  return (
    <div className="text-sm shrink-0 mt-auto text-zinc-600 border-t pt-2 border-zinc-200">
      {children}
    </div>
  )
}